import React from "react";
import moment from "moment";

import { makeStyles } from "@material-ui/core/styles";

import {
  List,
  TextField,
  FunctionField,
  ReferenceField,
  Filter,
  ReferenceInput,
  SelectInput,
  ReferenceArrayInput,
  AutoCompleteArrayInput,
  ShowButton,
  DeleteButton,
  FilterButton
} from "jazasoft";

import Datagrid from "../../../components/Datagrid";
import hasPrivilege from "../../../utils/hasPrivilege";
import { EstimationStateValue } from "../../../utils/types";
import { choicesEstimationState } from "../../../constants";
import { truncate } from "../../../utils/helpers";

const inputOptions = {
  xs: 12,
  fullWidth: true,
  options: { fullWidth: true }
};

const filters = (
  <Filter>
    <SelectInput label="Status" source="state" choices={choicesEstimationState} {...inputOptions} />
    <ReferenceInput
      label="Product"
      resource="products"
      source="productId"
      reference="products"
      pageSize={100}
      sort={{ field: "name", order: "asc" }}
      {...inputOptions}>
      <SelectInput />
    </ReferenceInput>
    <ReferenceInput
      label="Season"
      resource="seasons"
      source="seasonId"
      reference="seasons"
      pageSize={100}
      sort={{ field: "name", order: "asc" }}
      {...inputOptions}>
      <SelectInput />
    </ReferenceInput>
    <ReferenceArrayInput
      label="Customer"
      resource="customers"
      source="customerId"
      reference="customers"
      sort={{ field: "name", order: "asc" }}
      {...inputOptions}>
      <AutoCompleteArrayInput disablePortal={true} />
    </ReferenceArrayInput>
  </Filter>
);

const useStyles = makeStyles(theme => ({
  button: {
    margin: 0,
    padding: 0
  },
  buttonDelete: {
    width: theme.spacing(1)
  }
}));

const Estimation = props => {
  const classes = useStyles();
  const { roles, hasAccess } = props;
  return (
    <List
      key={roles?.join(",")}
      searchKeys={["poRef", "estId", "style", "cuChecklist.checklistId"]}
      actions={({ resource }) => (
        <div>
          <FilterButton showLabel={false} resource={resource} />
        </div>
      )}
      filters={filters}
      parse={({ state, checklistType, customerId, seasonId, productId }) => ({
        state: state ? `*${state}*` : state,
        checklistType: checklistType,
        "product.id": productId,
        "customer.id": customerId,
        "season.id": seasonId
      })}
      // filterDefaultValues={roles?.includes(Role.CUT_PLANNER) ? { state: EstimationState.PENDING } : {}}
      {...props}>
      <Datagrid classes={{ headerCell: classes.headerCell, rowCell: classes.rowCell }}>
        <TextField source="estId" />
        <ReferenceField
          label="Checklist Id"
          source="cuChecklistId"
          reference="cuChecklists"
          allowEmpty
          linkType={record => `/estimation/cuChecklists/${record.cuChecklistId}/view`}>
          <TextField source="checklistId" />
        </ReferenceField>
        <TextField source="poRef" />

        <TextField source="product.name" />
        <TextField source="season.name" />
        <TextField source="customer.name" />
        <TextField source="style" />
        {/* <TextField source="colors" /> */}
        <FunctionField source="colors" render={record => truncate(record?.colors?.replaceAll(",", ", "), 50)} />
        <FunctionField
          source="state"
          render={record =>
            record?.state
              .split(",")
              .map(state => ({ state, value: EstimationStateValue[state] }))
              .sort((a, b) => a.value - b.value)[0]?.state
          }
        />
        <FunctionField label="Created Date" render={record => `${moment(record.createdDate).format("ll")}`} />
        <ShowButton showLabel={false} cellClassName={classes.button} />
        {hasPrivilege(roles, hasAccess, "estimation", "delete") && <DeleteButton showLabel={false} cellClassName={classes.buttonDelete} />}
      </Datagrid>
    </List>
  );
};

export default Estimation;
